var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonSelect',{attrs:{"value":_vm.value,"placeholder":"请选择设备类型","clearable":_vm.clearable,"idKey":"EquipmentTypeId","labelKey":"EquipmentName","get-data-func":_vm.getDataFunc},on:{"input":v=>_vm.$emit('input',v),"select":v=>_vm.$emit('change',v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }